export const EMPLOYEE_STATUS = ["ยังไม่เป็นเจ้าของรถ", "พร้อม", "ไม่พร้อม"];